import styles from "../../styles/playerEcosystem.module.css";

const DOW = ["S", "M", "T", "W", "T", "F", "S"];

/**
 * Contribution-style activity calendar.
 * @param {{ calendar: {
 *   monthLabel?: string,
 *   cells?: Array<{ day: number | null, count: number, level: number }>,
 *   activeDaysInMonth?: number,
 *   monthMatches?: number,
 *   currentStreak?: number,
 *   longestActivityStreak?: number,
 * } | null }} props
 */
export default function ActivityCalendar({ calendar }) {
  if (!calendar?.cells?.length) return null;
  return (
    <div className={styles.calWrap} aria-label="Activity calendar">
      <div className={styles.calHead}>
        <p className={styles.sectionTitle}>{calendar.monthLabel}</p>
        <p className={styles.muted}>
          {calendar.monthMatches || 0} matches · {calendar.activeDaysInMonth || 0} active days
        </p>
      </div>
      <div className={styles.calDow} aria-hidden>
        {DOW.map((d, i) => (
          <span key={`${d}-${i}`}>{d}</span>
        ))}
      </div>
      <div className={styles.calGrid} role="grid" aria-label={calendar.monthLabel}>
        {calendar.cells.map((cell, i) => (
          <div
            key={cell.key || `pad-${i}`}
            className={`${styles.calCell} ${styles[`calL${cell.level}`] || ""}`}
            role={cell.day ? "gridcell" : "presentation"}
            aria-label={
              cell.day
                ? `${calendar.monthLabel || "Day"} ${cell.day}: ${cell.count} match${
                    cell.count === 1 ? "" : "es"
                  }`
                : undefined
            }
            title={
              cell.day
                ? `${cell.day}: ${cell.count} match${cell.count === 1 ? "" : "es"}`
                : undefined
            }
            aria-hidden={!cell.day}
          >
            {cell.day || ""}
          </div>
        ))}
      </div>
      <div className={styles.calStats}>
        <div>
          <p className={styles.statLabel}>Current streak</p>
          <p className={styles.statValue}>{calendar.currentStreak || 0}</p>
        </div>
        <div>
          <p className={styles.statLabel}>Longest streak</p>
          <p className={styles.statValue}>{calendar.longestActivityStreak || 0}</p>
        </div>
      </div>
    </div>
  );
}
